import React from 'react'

import assetUrl from 'src/utils/assetUrl'

const logo = assetUrl(RAILS_ASSET_URL('/logo-white.svg'))

const PoweredBy = () =>
  <p className="mb-0">
    <small><small>
      <small className="text-slightly-muted">powered by</small>
    </small></small>
    <img
      alt="Pledge"
      src={logo}
      className="logo mx-1"
      style={{ width: 'auto', height: '0.75em', marginTop: '0.25em' }}
    />
  </p>

export default PoweredBy
